module.exports = __webpack_public_path__ + "img/Simple-Taco.f8da3d07.png";